import { render, staticRenderFns } from "./FilesSidebarCallViewApp.vue?vue&type=template&id=198d5f93&scoped=true&"
import script from "./FilesSidebarCallViewApp.vue?vue&type=script&lang=js&"
export * from "./FilesSidebarCallViewApp.vue?vue&type=script&lang=js&"
import style0 from "./FilesSidebarCallViewApp.vue?vue&type=style&index=0&id=198d5f93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198d5f93",
  null
  
)

export default component.exports